export enum Role {
  ADMIN = 'ROLE_ADMIN',
}
